import { deleteData, getData, postData, putData } from 'src/api/http.service';
import { handleApiError, handleApiSuccess } from 'src/utils/general.utils';
import { ApiCallFailedAction, ApiCallInProgress, ApiCallSuccessAction } from './uistate.action';

// later, i can dynamically add meta data to these actions to make them more declarative.
const SubjectManageActionTypes = {
  API_ERROR: '[API] : Api call errored.',

  GET_ALL_SUBJECTS: '[API] : Get All Subjects action.',
  // ALL_FINISHED_SUBJETCS_SUCCESS: "[API] : Get all finished subjects action.",
  ALL_SUBJECTS_SUCCESS: '[API] : All subjects success action.',
  GENERATE_SUBJECT_LIST: '[UI] : Generate all subject list.',
  CREATE_A_SUBJECT: '[API] : Create a subject.',
  CREATE_SUBJECT_SUCCESS: '[API] : Create subject successfull.',
  UPDATE_SUBJECT_SUCCESS: '[API] : Update subject successfull.',
  CREATE_A_UNIT: '[API] : Create a unit.',
  CREATE_UNIT_SUCCESS: '[API] : Create unit successfull.',
  CREATE_TOPIC_OR_SUBTOPIC: '[API] : Create topic or subtopic.',
  CREATE_TOPIC_OR_SUBTOPIC_SUCCESS: '[API] : Create topic or subtopic success.',

  SEND_FOR_REVIEW: '[API] : Send subject for review.',
  SEND_FOR_REVIEW_SUCCESS: '[API] : Subject review successfull.',

  DELETE_SUBJECT: '[API] : Delete a subject.',
  DELETE_SUBJECT_SUCCESS: '[API] : Delete a subject success.',
  DELETE_UNIT_TOPIC_SUBTOPIC: '[API] : Delete unit, topic or subtopic.',
  DELETE_UNIT_TOPIC_SUBTOPIC_SUCCESS: '[API] : Delete unit, topic or subtopic success.',

  GET_USERS: '[API] : Get all users.',
  ALL_USERS_SUCCESS: '[API] : All users success action.',

  GET_SUBJECT_UNITS: '[API] : Get all units for Subject.',
  SUBJECT_UNITS_SUCCESS: '[API] : All units of subject received.',

  BUILD_SUBJECT_UNIT_PAYLOAD: '[UI] : Build paylod for Units from subjectId api payload.',

  GET_SUBJECT_VIDEOS: '[API] : Get all the videos for selected subject.',
  GET_SELECTED_VIDEO_URL: '[API] : Get selected video url action.',

  GET_SUBJECT_ASSIGNEES: '[API] : Get Subject assigness by subjectID.',

  ATTACH_SUBTOPIC_VIDEO: '[API] : Attach video to sub topic.',
};

// Plain Actions *********************************************************************************

function AttachVideoToSubTopicSuccessAction(payload) {
  return {
    type: SubjectManageActionTypes.ATTACH_SUBTOPIC_VIDEO,
    payload,
  };
}

function AllSubjectsSuccessAction(payload) {
  return {
    type: SubjectManageActionTypes.ALL_SUBJECTS_SUCCESS,
    payload,
  };
}

function GenerateAllSubjectsList(payload) {
  return {
    type: SubjectManageActionTypes.GENERATE_SUBJECT_LIST,
    payload,
  };
}

function CreateSubjectSuccessAction(payload) {
  return {
    type: SubjectManageActionTypes.CREATE_SUBJECT_SUCCESS,
    payload,
  };
}

function UpdateSubjectSuccessAction(payload) {
  return {
    type: SubjectManageActionTypes.UPDATE_SUBJECT_SUCCESS,
    payload,
  };
}

function SendForReviewSuccessAction(payload) {
  return {
    type: SubjectManageActionTypes.SEND_FOR_REVIEW_SUCCESS,
    payload,
  };
}

function CreateOrUpdateUnitSuccessAction(payload) {
  return {
    type: SubjectManageActionTypes.CREATE_UNIT_SUCCESS,
    payload,
  };
}

function CreateTopicOrSubtopicSuccessAction(payload) {
  return {
    type: SubjectManageActionTypes.CREATE_TOPIC_OR_SUBTOPIC_SUCCESS,
    payload,
  };
}

function DeleteASubjectSuccessAction(payload) {
  return {
    type: SubjectManageActionTypes.DELETE_SUBJECT_SUCCESS,
    payload,
  };
}

function DeleteUnitTopicOrSubTopicSuccessAction(payload) {
  return {
    type: SubjectManageActionTypes.DELETE_UNIT_TOPIC_SUBTOPIC_SUCCESS,
    payload,
  };
}

function AllUsersSuccess(payload) {
  return {
    type: SubjectManageActionTypes.ALL_USERS_SUCCESS,
    payload,
  };
}

function SubjectUnitsSuccess(payload) {
  return {
    type: SubjectManageActionTypes.SUBJECT_UNITS_SUCCESS,
    payload,
  };
}

function BuildSubjectUnitPayload(payload) {
  return {
    type: SubjectManageActionTypes.BUILD_SUBJECT_UNIT_PAYLOAD,
    payload,
  };
}

function SubjectVideosSuccess(payload) {
  return {
    type: SubjectManageActionTypes.GET_SUBJECT_VIDEOS,
    payload,
  };
}

function SelectedVideoUrlSuccess(payload) {
  return {
    type: SubjectManageActionTypes.GET_SELECTED_VIDEO_URL,
    payload,
  };
}

function GetAssigneesSuccess(payload) {
  return {
    type: SubjectManageActionTypes.GET_SUBJECT_ASSIGNEES,
    payload,
  };
}

// ASYNC actions ************************************************************************************

export function AttachVideoToSubTopicAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await putData(url, body, headers);
      dispatch(AttachVideoToSubTopicSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

function GetAllSubjectsAction(url, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(url, headers);
      dispatch(AllSubjectsSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

function CreateASubjectAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postData(url, body, headers);
      dispatch(CreateSubjectSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

function UpdateASubjectAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await putData(url, body, headers);
      dispatch(UpdateSubjectSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

function GetAssigneesBySubjectIdAction(url, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(url, headers);
      dispatch(GetAssigneesSuccess(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

function GetSubjectAssigneeAndUnitsAction(urls, headers) {
  const { assigneeUrl, selectedSubjectUrl } = urls;
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const assignee = await getData(assigneeUrl, headers);

      const selectedSubject = await getData(selectedSubjectUrl, headers);

      dispatch(ApiCallSuccessAction(handleApiSuccess()));
      return {
        assignee: assignee.data,
        selectedSubject: selectedSubject.data,
      };
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err)));
      return false;
    }
  };
}

function SendForReviewAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postData(url, body, headers);
      // on success there wont be any data from the backend so better show a success banner with refresh.
      dispatch(SendForReviewSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

function CreateOrUpdateUnitAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await putData(url, body, headers);
      // on success there wont be any data from the backend so better show a success banner with refresh.
      dispatch(CreateOrUpdateUnitSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

function CreateTopicOrSubtopicAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await putData(url, body, headers);
      // on success there wont be any data from the backend so better show a success banner with refresh.
      dispatch(CreateTopicOrSubtopicSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

function DeleteASubjectAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await deleteData(url, body, headers);
      // on success there wont be any data from the backend so better show a success banner with refresh.
      dispatch(DeleteASubjectSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

function DeleteUnitTopicOrSubTopicAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await putData(url, body, headers);
      // on success there wont be any data from the backend so better show a success banner with refresh.
      dispatch(DeleteUnitTopicOrSubTopicSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

function GetAllUsersAction(payload, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(payload, headers);
      dispatch(AllUsersSuccess(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

function GetSubjectUnitsAction(payload, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(payload, headers);
      dispatch(SubjectUnitsSuccess(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

function GetSubjectVideosAction(url, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(url, headers);
      dispatch(SubjectVideosSuccess(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

function GetSelectedVideoUrlAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postData(url, body, headers);
      dispatch(SelectedVideoUrlSuccess({ response, metaData }));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return true;
    }
  };
}

export {
  SubjectManageActionTypes,
  GenerateAllSubjectsList,
  GetAllSubjectsAction,
  CreateASubjectAction,
  UpdateASubjectAction,
  CreateSubjectSuccessAction,
  SendForReviewAction,
  SendForReviewSuccessAction,
  CreateOrUpdateUnitSuccessAction,
  CreateOrUpdateUnitAction,
  CreateTopicOrSubtopicSuccessAction,
  CreateTopicOrSubtopicAction,
  DeleteASubjectSuccessAction,
  DeleteASubjectAction,
  DeleteUnitTopicOrSubTopicAction,
  DeleteUnitTopicOrSubTopicSuccessAction,
  GetAllUsersAction,
  AllUsersSuccess,
  GetSubjectUnitsAction,
  BuildSubjectUnitPayload,
  GetSubjectVideosAction,
  GetSelectedVideoUrlAction,
  SelectedVideoUrlSuccess,
  GetSubjectAssigneeAndUnitsAction,
  GetAssigneesSuccess,
  GetAssigneesBySubjectIdAction,
};
